/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationModel } from './NotificationModel';
import {
    NotificationModelFromJSON,
    NotificationModelFromJSONTyped,
    NotificationModelToJSON,
} from './NotificationModel';

/**
 * 
 * @export
 * @interface GetNotifications200Response
 */
export interface GetNotifications200Response {
    /**
     * 
     * @type {Array<NotificationModel>}
     * @memberof GetNotifications200Response
     */
    notifications?: Array<NotificationModel>;
    /**
     * 未読の通知の総数
     * @type {number}
     * @memberof GetNotifications200Response
     */
    totalUnreadNotificationNum?: number;
}

/**
 * Check if a given object implements the GetNotifications200Response interface.
 */
export function instanceOfGetNotifications200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetNotifications200ResponseFromJSON(json: any): GetNotifications200Response {
    return GetNotifications200ResponseFromJSONTyped(json, false);
}

export function GetNotifications200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNotifications200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'notifications': !exists(json, 'notifications') ? undefined : ((json['notifications'] as Array<any>).map(NotificationModelFromJSON)),
        'totalUnreadNotificationNum': !exists(json, 'totalUnreadNotificationNum') ? undefined : json['totalUnreadNotificationNum'],
    };
}

export function GetNotifications200ResponseToJSON(value?: GetNotifications200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notifications': value.notifications === undefined ? undefined : ((value.notifications as Array<any>).map(NotificationModelToJSON)),
        'totalUnreadNotificationNum': value.totalUnreadNotificationNum,
    };
}

